export class ResponseModel {
    statusCode:number = undefined
    message:string = undefined
    data:any = undefined
}

export class NotificationTokenModel{
    token: string = undefined
    os: string = undefined
}